import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as DownArrow } from "../../../../assets/images/downArrow.svg";
import { ReactComponent as DisablePencilImg } from "../../../../assets/images/disableImg.svg";
import { getSentenceCase } from "../../../../utils/utilityFunctions/stringUtility";

const ManageColDialog = ({ field, fieldData, openDropDown, handleFieldVisibility, orderedThead, EditExtraField }) => {
  console.log(field, fieldData, "helllomanageCol");

  const [isMainChecked, setIsMainChecked] = useState(false);
  const [isMainAddInfoChecked, setIsMainAddInfoChecked] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedInfOptions, setSelectedInfOptions] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(openDropDown);
  const additionalFieldsRef = useRef(null);
  const options = Object.keys(fieldData);
  // const addInfoOptions = ["Date", "Transaction Type", "Number"];

  useEffect(() => {
    // selectedOptions(Object.keys(fieldData?.filter((field) => field.visibilty)))
  }, [fieldData]);
  const handleMainCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsMainChecked(checked);
    setSelectedOptions(checked ? options : []);
  };

  const handleOptionChange = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedOptions((prev) => {
        const updatedOptions = [...prev, value];

        if (updatedOptions.length === options.length) {
          setIsMainChecked(true);
        }
        return updatedOptions;
      });
    } else {
      setSelectedOptions((prev) => {
        const updatedOptions = prev.filter((option) => option !== value);

        setIsMainChecked(false);
        return updatedOptions;
      });
    }
  };

  const toggleDropdown = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    setIsDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isDropdownOpen) additionalFieldsRef?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [isDropdownOpen]);

  return (
    <div className=" m-3 mt-0 border rounded ">
      <div
        className="border-y rounded p-2 px-4 flex items-center hover:text-2999BC  space-x-2"
        ref={additionalFieldsRef}
      >
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={isMainChecked}
            onChange={handleMainCheckboxChange}
            className="form-checkbox focus:ring-0"
          />
        </label>
        <div className="flex items-center justify-between w-full cursor-pointer" onClick={toggleDropdown}>
          <div className="text-lg font-medium text-535252">{field}</div>

          <div className={`transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : ""}`}>
            <DownArrow fill="#535252" />
          </div>
        </div>
      </div>

      {isDropdownOpen && (
        <div className=" py-4 px-4 border-y rounded shadow-md ">
          {console.log(options, "colDialogOptions")}
          {options.map((option) => (
            <label key={option} className="relative flex items-center justify-between py-1 mb-2 last:mb-0 group">
              <div className="flex items-center space-x-2 hover:text-2999BC">
                {/* {console.log("optionfieldData", option , fieldData[option].visibility)} */}
                <input
                  type="checkbox"
                  value={option}
                  checked={fieldData[option].visibility}
                  onChange={() => handleFieldVisibility(option)}
                  className="form-checkbox focus:ring-0 cursor-pointer"
                />
                <span
                  className={`text-base ${fieldData[option].visibility ? "text-black" : "text-[#888888] "}   font-400 hover:text-2999BC`}
                >
                  {orderedThead?.find((item) => item.value === option)?.label}
                </span>
              </div>

              <button
                type="button"
                onClick={(e) => {
                  EditExtraField(e, option);
                }}
              >
                <i className="bi bi-pencil-fill text-gray-300 mr-4 hover:text-667279 opacity-0 group-hover:opacity-100"></i>
              </button>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ManageColDialog;
